import { IEnvironment } from './IEnvironment';

export { IEnvironment };

